// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","9055":"a9950acc"}[chunkId] + ".chunk.css";
};